import { createRouter, createWebHistory } from 'vue-router';

import routes from './routes';
import AnalyticsHelper from 'dashboard/helper/AnalyticsHelper';
import { validateRouteAccess } from '../helpers/RouteHelper';

// See app/javascript/dashboard/routes/index.js for why this reads
// window.chatwootConfig.relativeUrlRoot.
const relativeUrlRoot = window.chatwootConfig?.relativeUrlRoot || '';
export const router = createRouter({
  history: createWebHistory(relativeUrlRoot),
  routes,
});

const sensitiveRouteNames = ['auth_password_edit'];

export const initalizeRouter = () => {
  router.beforeEach((to, _, next) => {
    if (!sensitiveRouteNames.includes(to.name)) {
      AnalyticsHelper.page(to.name || '', {
        path: to.path,
        name: to.name,
      });
    }

    return validateRouteAccess(to, next, window.chatwootConfig);
  });
};

export default router;
